import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ViewChild,
  output,
  inject,
} from '@angular/core';

import moment from 'moment-timezone';

import { TranslatePipe } from '@core/i18n-legacy';
import { getFormattedTimezone } from '@core/time-legacy';
import {
  DropdownItemComponent,
  FormFieldComponent,
  IconComponent,
  InputComponent,
} from '@core/user-interface-legacy';
import { deepClone, includesWithTrim } from '@core/utils-legacy';

interface TimezoneListItem {
  timezone: string;
  timezoneFormatted: string;
}

@Component({
  selector: 'rt-time-zone-picker-dropdown-list',
  templateUrl: './time-zone-picker-dropdown-list.component.html',
  styleUrls: ['./time-zone-picker-dropdown-list.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DropdownItemComponent,
    FormFieldComponent,
    IconComponent,
    InputComponent,
    TranslatePipe,
  ],
})
export class TimeZonePickerDropdownListComponent {
  protected readonly cdRef = inject(ChangeDetectorRef);

  public zoneSelect = output<string>();

  @ViewChild('searchInput', { static: true }) public searchInput: InputComponent;

  public filteredZones: TimezoneListItem[];
  public isEmpty: boolean = true;

  private timeZonesList: TimezoneListItem[];

  public ngOnInit(): void {
    this.timeZonesList = moment.tz
      .names()
      .map(tz => ({ timezone: tz, timezoneFormatted: getFormattedTimezone(tz) }));
    this.filteredZones = deepClone(this.timeZonesList);
    this.cdRef.detectChanges();
  }

  public onInputChange(event: any): void {
    this.searchInput.setValue(event.target.value);
    this.isEmpty = event.target.value.length === 0;
    const query = event.target.value;
    this.filteredZones = this.timeZonesList.filter(zone => includesWithTrim(zone.timezone, query));
    this.cdRef.detectChanges();
  }

  public clearField(): void {
    this.searchInput.input.nativeElement.value = '';
    this.searchInput.setValue('');
    this.filteredZones = deepClone(this.timeZonesList);
    this.cdRef.detectChanges();
  }

  public trackByZone(index: number, timezone: TimezoneListItem): TimezoneListItem {
    return timezone;
  }
}
